module.exports = __webpack_public_path__ + "img/dennies-kannamalil.9f72d85e.jpeg";